import { TFunction } from 'i18next'
import { ServiceStatus } from '../types'

export const SERVICE_STATUS = (t: Function) => [
    {
        value: ServiceStatus.WaitingConfirm,
        label: t('service-status.waiting-confirm'),
        color: 'primary',
    },
    {
        value: ServiceStatus.WaitingCreateService,
        label: t('service-status.waiting-create-service'),
        color: 'primary',
    },
    {
        value: ServiceStatus.Active,
        label: t('service-status.active'),
        color: 'success',
    },
    {
        value: ServiceStatus.PendingTerminated,
        label: t('service-status.pending-terminated'),
        color: 'warning',
    },
    {
        value: ServiceStatus.Cancelled,
        label: t('service-status.cancelled'),
        color: 'error',
    },
    {
        value: ServiceStatus.Trialing,
        label: t('service-status.trialing'),
        color: 'warning',
    },
    {
        value: ServiceStatus.Rejected,
        label: t('service-status.rejected'),
        color: 'error',
    },
    {
        value: ServiceStatus.Resubmit,
        label: t('service-status.on-resubmit-information'),
        color: 'info',
    },
]

export const DNS_MANAGEMENT_TYPES = [
    { value: 'cname', label: 'CNAME' },
    { value: 'a', label: 'A' },
    { value: 'aaaa', label: 'AAAA' },
    { value: 'mx', label: 'MX' },
    { value: 'txt', label: 'TXT' },
    { value: 'spf', label: 'SPF' },
]
export const METADATA_KEYS = [
    { value: 'id', label: 'ID' },
    { value: 'ip', label: 'IP' },
    { value: 'user', label: 'USER' },
    { value: 'pass', label: 'PASS' },
    { value: 'link', label: 'LINK' },
    { value: 'config', label: 'CẤU HÌNH' },
]

export const INTERNAL_SERVICE_STORAGE_PREFIX_URLS = {
    Notifications: 'services/notifications',
}

// Số ngày công nợ mặc định khi service chưa có payment_term_days (khớp default BE)
export const DEFAULT_PAYMENT_TERM_DAYS = 14

export enum ServiceCreatableType {
    // Marks a service linked to a servicemgmt (margarita) services.id via
    // service_creatable_uuid — set by the datacentral BE (CreatableTypeServiceMgmt).
    // Drives per-service reconciliation/monitoring scope instead of org-wide.
    ServiceMgmt = 'ServiceMgmt',

    // SwiftFederation
    CDN = 'SwiftFederation.CDN',
    Transcoding = 'SwiftFederation.Transcoding',
    Transmuxing = 'SwiftFederation.Transmuxing',
    Recording = 'SwiftFederation.Recording',
    StorageLFD = 'SwiftFederation.StorageLFD',
    StorageOSS = 'SwiftFederation.StorageOSS',

    // Vnis
    Vnis = 'Mlytics.Vnis',
    VnisDomain = 'Mlytics.Domain',
    VnisRequest = 'Mlytics.Request',
    VnisTraffic = 'Mlytics.Traffic',

    // Email
    EmailServer = 'Email.Server',
    EGPlatform = 'Email.EGPlatform',

    // VPS
    Hosting = 'Cloud.Hosting',
    CloudVPS = 'Cloud.VPS',
    VCloud = 'Cloud.VCloud',
    CloudGcore = 'Cloud.Gcore',

    // Dedicate Service
    VBM = 'Server.VBM',
    Dedicated = 'Server.Dedicated',
    Colocation = 'Server.Colocation',

    // Domain
    DomainVNNIC = 'Domain.VNNIC',
    DomainTLDs = 'Domain.TLDs',

    // SSL
    SSL = 'SSL.SSL',
}

export const ServiceSupportRegisters = [
    ServiceCreatableType.CDN,
    ServiceCreatableType.Transcoding,
    ServiceCreatableType.Transmuxing,
    ServiceCreatableType.Recording,
    ServiceCreatableType.StorageLFD,
    ServiceCreatableType.StorageOSS,
    ServiceCreatableType.Vnis,
    ServiceCreatableType.VCloud,
    ServiceCreatableType.DomainVNNIC,
    ServiceCreatableType.DomainTLDs,
]

export const ServiceSupportAddons = [ServiceCreatableType.CDN]

export const ServiceSupportRenews = [
    ServiceCreatableType.DomainVNNIC,
    ServiceCreatableType.DomainTLDs,
]

export const ServiceSupportStatements = [
    ServiceCreatableType.Colocation,
    ServiceCreatableType.CDN,
    ServiceCreatableType.Transcoding,
    ServiceCreatableType.Transmuxing,
    ServiceCreatableType.Recording,
    ServiceCreatableType.StorageLFD,
    ServiceCreatableType.StorageOSS,
    ServiceCreatableType.Vnis,
]

export const ALERT_THRESHOLD_TYPES = (t: TFunction) => [
    {
        value: 'absolute',
        label: t('alerts.thresholds.absolute'),
    },
    {
        value: 'percentage',
        label: t('alerts.thresholds.percentage'),
    },
]

// SLA Configuration Constants
export const TIMEZONE_OPTIONS = [
    { value: 'Asia/Ho_Chi_Minh', label: 'Việt Nam (UTC+7)' },
    { value: 'Asia/Bangkok', label: 'Thailand (UTC+7)' },
    { value: 'Asia/Singapore', label: 'Singapore (UTC+8)' },
    { value: 'Asia/Tokyo', label: 'Japan (UTC+9)' },
    { value: 'UTC', label: 'UTC' },
]

export const WORK_DAYS_OPTIONS = [
    { value: 1, label: 'T2' },
    { value: 2, label: 'T3' },
    { value: 3, label: 'T4' },
    { value: 4, label: 'T5' },
    { value: 5, label: 'T6' },
    { value: 6, label: 'T7' },
    { value: 0, label: 'CN' },
]

export const NOTIFICATION_CHANNELS = [
    { value: 'email', label: 'Email' },
    { value: 'sms', label: 'SMS' },
    { value: 'slack', label: 'Slack' },
    { value: 'teams', label: 'Teams' },
]

export const PRIORITY_OPTIONS = [
    { value: 'critical', label: 'Critical' },
    { value: 'high', label: 'High' },
    { value: 'medium', label: 'Medium' },
    { value: 'low', label: 'Low' },
]
